<div class="main-modal-container">
    <!-- Modal Header -->
    <div class="cross-btn-cont">
        <div cygovSvgIcon [svgName]="'x-icon-type2'" class='cross-btn'
            (click)="resetAndClosePopup()">
        </div>
    </div>

    <!-- Modal Body -->
    <div class="lato-18-n-vw dynamic-label-popup-body dynamic-label-bulk-upload-cont">
        <div class="steps-toggle-icons-cont">
            <ng-container *ngFor="let step of steps; let i = index">
                <div
                    [ngClass]="['bulk-dynamic-label-step', 'bulk-'+step?.num?.toLowerCase()+'-step']">
                    <div class="round-checkbox">
                        <input [id]="'label-step-icon'+i" type="radio" [name]="'step-icon'+i"
                            disable [checked]="step.active || step.completed" />
                        <label [for]="'label-step-icon'+i"
                            class="lato-14-n-vw capitalize label standard disable">
                        </label>

                        <div cygovSvgIcon [svgName]="'right-tick'" class="completed-right-tick"
                            [ngClass]="{ 'opacity-class': step.completed}">
                        </div>
                    </div>
                    <div class='round-checkbox-label'>
                        <span class='lato-14-n-vw'
                            [ngClass]="{'disabled-color':!step.active && !step.completed, 'txt-blue':step.active && !step.completed }">{{
                            step.title }}</span>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class='steps-toggle-body'>
            <!-- First Step: Download Template -->
            <ng-container *ngIf="steps[0].active">
                <ng-container *ngTemplateOutlet="stepFirst;">
                </ng-container>
            </ng-container>

            <!-- Second Step: Upload Template -->
            <ng-container *ngIf="steps[1].active">
                <ng-container *ngTemplateOutlet="stepSecond;">
                </ng-container>
            </ng-container>

            <!-- Third Step: Results -->
            <ng-container *ngIf="steps[2].active">
                <div class="bulk-dynamic-label-third-step-content">
                    <div class="header-container">
                        <!-- It will be divided into two sections  Title and Actions-->
                        <div class="title-container">
                            @for (section of dynamicLabelManagerSections; track section) {
                            <div class="title-sections lato-16-n-vw">
                                <div class="title-sections-inner"
                                    [ngClass]="{'selected': section.isSelected}"
                                    (click)="toggleSection(section)">
                                    {{
                                    section.name
                                    }}
                                </div>
                            </div>
                            }
                        </div>
                        <div class="actions-container">
                            @if(isEditMode) {
                            <div (click)="addNewData(currentTab)"
                                class="lato-16-n-vw add-button add-user-btn" cygovUserPermission>
                                <span class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
                                <span class="button-text">Add New</span>
                            </div>
                            <div class="delete-dynamic-label-btn"
                                [ngClass]="{'delete-dynamic-label-btn-disabled': false }"
                                cygovSvgIcon ngbTooltip="Delete" container="body"
                                [svgName]="'trash-icon-2'" (click)="clearUploadResults()">
                            </div>
                            <div>
                                <cygov-button class="centered-button lato-18-b-vw"
                                    [buttonText]="'SAVE'" [buttonWidth]="'5vw'"
                                    [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
                                    [buttonHeight]="'3.4vh'" (click)="saveUploadResults()">
                                </cygov-button>
                            </div>
                            <div class='edit-users-btn' cygovSvgIcon [svgName]="'x-icon-blue'"
                                (click)="isEditMode = false" (click)="resetUploadResults()">
                            </div>
                            } @else {
                            <div class="delete-dynamic-label-btn"
                                [ngClass]="{'delete-dynamic-label-btn-disabled': false }"
                                cygovSvgIcon ngbTooltip="Delete" container="body"
                                [svgName]="'trash-icon-2'" (click)="clearUploadResults()">
                            </div>
                            <div class='edit-users-btn' [ngClass]="'pencil-svg'" cygovSvgIcon
                                [svgName]="'edit-icon'" (click)="isEditMode = true">
                            </div>
                            }
                        </div>
                    </div>
                    <div class="content-container">
                        <div class="content-container-inner">
                            <div class="upload-results-header">
                                <div class="upload-results-title">
                                    <span class="lato-18-n-vw">Upload Results:</span>
                                    <span class="lato-14-n-vw results-summary">
                                        <span class="cleared-count">{{ uploadResult?.cleared || 0 }}
                                            Cleared</span>
                                        <span class="failed-count-text"
                                            *ngIf="uploadResult?.failed > 0">
                                            &nbsp;{{ uploadResult?.failed }} Failed:
                                            <span
                                                *ngFor="let failed of uploadResult?.failedItems?.slice(0, 3); let i = index"
                                                class="failed-count-number">
                                                #{{ failed?.rowNumber || i + 1 }}<span
                                                    *ngIf="i < 2 && i < uploadResult?.failedItems?.length - 1">,
                                                </span>
                                            </span>
                                            <span *ngIf="uploadResult?.failedItems?.length > 3"
                                                class="more-link cursor-pointer failed-count-more"
                                                (click)="openFailedItemsModal()">
                                                more...</span>
                                        </span>
                                    </span>
                                </div>
                                <div class="upload-results-actions">
                                    <div class="search-bar">
                                        <div class="search-icon" cygovSvgIcon
                                            [svgName]="'search-icon'"></div>
                                        <input type="text" class="form-control search"
                                            aria-label="Search" placeholder="Search"
                                            [(ngModel)]="searchText" name="search"
                                            (keyup)="searchDynamicLabelManagerItems(searchText)"
                                            spellcheck="true" />
                                    </div>
                                </div>
                            </div>
                            <div class="dynamic-label-manager-container-wrapper">
                                <ng-container *ngTemplateOutlet="stepThird">
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-container>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="lato-22-n-vw dynamic-label-popup-footer">
        <cygov-button *ngIf="!steps[0].active" class="button-margin"
            [buttonText]="'< Previous Step'" [buttonColor]="'#030715'" [buttonWidth]="'auto'"
            [textColor]="'#C5C9D1'" (buttonPressed)="moveBackToOldStep()"
            [disableClick]="disableBackBtn">
        </cygov-button>
        <cygov-button class="button-margin" [buttonText]="nextStepBtnText" [buttonWidth]="'5.1vw'"
            [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'" (buttonPressed)="moveToNextStep()"
            [disableClick]="disableBtn">
        </cygov-button>
    </div>
</div>


<!-- ============= First Step Content: Download Template ================= -->
<ng-template #stepFirst>
    <div class="bulk-dynamic-label-step-content abs-centre">
        <div class='download-csv-box cursor-pointer' (click)="downloadCSVTemplate()">
            <div class='download-btn-icon abs-centre'>
                <div cygovSvgIcon [svgName]="'download-report-icon'" class='download-icon-svg'>
                </div>
            </div>
            <div class='download-btn-text lato-25-n-vw'>
                Download Template
            </div>
        </div>
    </div>
</ng-template>

<!-- ============= Second Step Content: Upload Template ================= -->
<ng-template #stepSecond>
    <div class="bulk-dynamic-label-step-content bulk-dynamic-label-second-step-content abs-centre">
        <cygov-upload-file [uploadPath]='""' [uploadType]="'.xlsx'" [restrictFileDrop]="'.xlsx'"
            [displayMessage]="'Uploading Template'" [loaderType]="uploadStateEnum.STYLE1"
            [requiredInfo]="requiredInfo" [isFakeUpload]="true" [invalidFile]="invalidFileData"
            [multiSelect]="false" [customMessage]="'Drag template here or '">
        </cygov-upload-file>
    </div>
</ng-template>

<!-- ============= Third Step Content: Results ================= -->
<ng-template #stepThird let-items="items" let-title="title" let-type="type"
    let-searchObj="searchObj">

    <div class="dynamic-label-manager-container">
        <table class="dynamic-label-manager-table">
            <thead>
                <tr>
                    <th [ngStyle]="{'width': '10%'}">
                        <div class="checkbox-container">
                            <cygov-checkbox [width]="1.8" [height]="1.8"
                                [useViewPortDimensions]="true"
                                [isChecked]="filteredDynamicLabelManagerItems[currentTab].isSelectAll"
                                (click)="selectAllItems()" />
                        </div>

                    </th>
                    <th [ngStyle]="{'width': '10%'}">
                        <div class="header-item-container">
                            <div class="item lato-18-b-vw">#</div>
                        </div>
                    </th>
                    @for(header of filteredDynamicLabelManagerItems[currentTab].headers; track
                    header) {
                    <th>
                        <div class="header-item-container" [ngStyle]="{'width': header.width}">
                            <div class="item lato-18-b-vw">{{ header.name }}</div>
                            <div class="sort-buttons">
                                <div class="icon-class-btn"
                                    [ngClass]="{'dsc':header.isSortable, 'active-sort': header.isSortable}"
                                    cygovSvgIcon [svgName]="'arrow-sort'"
                                    (click)="sortDynamicLabelManagerItems(header.name, header.isSortable)">
                                </div>
                            </div>
                        </div>
                    </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for(item of filteredDynamicLabelManagerItems[currentTab].values; track item; let
                indx =
                $index) {
                <tr>
                    <td [ngStyle]="{'width': '10%'}">
                        <div class="checkbox-container">
                            <cygov-checkbox [width]="1.8" [height]="1.8"
                                [useViewPortDimensions]="true" [isChecked]="item.isSelected"
                                (click)="selectItem(item)" />
                        </div>
                    </td>
                    <td [ngStyle]="{'width': '10%'}">
                        <div class="item">{{ indx + 1 }}</div>
                    </td>
                    @for(header of filteredDynamicLabelManagerItems[currentTab].headers; track
                    header.name)
                    {

                    @if(!isEditMode) {
                    <td>
                        <div class="item lato-16-n-vw" [ngStyle]="{'width': header.width}"
                            [ngClass]="{'red-border': header.name === 'Policy Categories' && (item[header.name] === null || item[header.name] === undefined || item[header.name] === '')}">
                            {{
                            item[header.name] }}</div>
                    </td>
                    } @else {

                    @if(header.name === 'Policy Categories') {
                    <td>
                        <div class="item edit-mode-table-cell"
                            [ngClass]="{'red-border': header.name === 'Policy Categories' && (item[header.name] === null || item[header.name] === undefined || item[header.name] === '')}">
                            <ng-container *ngTemplateOutlet="customDropdown; context: { 
                                    $implicit: item, 
                                    header: header, 
                                    items: defaultCategories 
                                  }"></ng-container>
                        </div>
                    </td>
                    } @else {
                    <td>
                        <div class="item edit-mode-table-cell" [ngStyle]="{'width': header.width}">
                            <input type="text" class="edit-mode-input lato-16-n-vw"
                                [(ngModel)]="item[header.name]" focus />
                        </div>
                    </td>
                    }
                    }
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
    <!-- Failed Items Modal -->
    <div class="failed-items-modal-overlay" *ngIf="showFailedItemsModal"
        (click)="closeFailedItemsModal()">
        <div class="failed-items-modal-container" (click)="$event.stopPropagation()">
            <!-- Modal Header -->
            <div class="failed-items-modal-header">
                <div class="close-btn" (click)="closeFailedItemsModal()">
                    <span cygovSvgIcon [svgName]="'x-icon-type2'"></span>
                </div>
            </div>

            <!-- Modal Body -->
            <div class="failed-items-modal-body">
                <div class="failed-items-title lato-16-n-vw">
                    The following labels were unable to upload:
                </div>
                <div class="failed-items-divider"></div>
                <div class="failed-items-list">
                    <div class="failed-item lato-14-n-vw"
                        *ngFor="let item of uploadResult?.failedItems; let i = index">
                        #{{ item?.rowNumber || i + 1 }}
                    </div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="failed-items-modal-footer">
                <cygov-button [buttonText]="'PLEASE REVIEW'" [buttonWidth]="'8vw'"
                    [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'" [buttonHeight]="'3.5vh'"
                    (click)="closeFailedItemsModal()">
                </cygov-button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Add this ng-template at the bottom of your component HTML file -->
<ng-template #customDropdown let-item let-header="header" let-items="items">
    <div class="custom-dropdown-wrapper" [ngClass]="{'dropdown-open': item.isDropdownOpen}">
        <!-- Dropdown trigger -->
        <div class="custom-dropdown-trigger" (click)="toggleDropdown(item)">
            <span class="dropdown-value lato-14-n-vw">
                {{ item[header.name] || 'Choose' }}
            </span>
            <div class="arrow-icon" [ngClass]="{'expanded': item.isDropdownOpen}" cygovSvgIcon
                [svgName]="'arrow-right-type3'">
            </div>
        </div>

        <!-- Dropdown panel -->
        <div class="custom-dropdown-panel" *ngIf="item.isDropdownOpen">
            <!-- Add New Button -->
            <div class="add-new-option" (click)="showAddBox = true">
                <span class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
                <span class="lato-14-n-vw">Add New</span>
            </div>

            @if(showAddBox) {
            <div class="custom-add-box">
                <input type="text" name="newTag" class="custom-add-input" autofocus
                    [(ngModel)]="newTagValue" />
                <div class="custom-add-close" (click)="showAddBox = false">
                    <span>×</span>
                </div>
                <button class="add-btn lato-12-n-vw" (click)="onAddNewCategory()">Add</button>
            </div>
            }

            <!-- Dropdown Options -->
            <div class="dropdown-options-container">
                <div class="dropdown-option lato-14-l-vw"
                    *ngFor="let option of items; let i = index"
                    (click)="selectOption(item, header, option)"
                    [ngClass]="{'selected': item[header.name] === option.value}">

                    <span>{{ option.name }}</span>
                </div>
            </div>
        </div>

        <!-- Backdrop to close dropdown when clicking outside -->
        <div class="dropdown-backdrop" *ngIf="item.isDropdownOpen" (click)="closeDropdown(item)">
        </div>
    </div>
</ng-template>